"use client";

/**
 * The browser's three portalled surfaces: the file preview drawer and the
 * create-folder / upload modals.
 *
 * Grouped because they share every input (the current folder + account) and all
 * three succeed the same way — by refreshing the listing behind them.
 */

import React from "react";

import { GoogleDriveCreateFolderModal } from "../GoogleDriveCreateFolderModal";
import { GoogleDrivePreviewDrawer } from "../GoogleDrivePreviewDrawer";
import { GoogleDriveUploadModal } from "../GoogleDriveUploadModal";

export interface GoogleDriveBrowserOverlaysProps {
  previewFile: React.ComponentProps<typeof GoogleDrivePreviewDrawer>["file"];
  isSecondAccount: boolean;
  parentId: string | undefined;
  driveId: string | undefined;
  createFolderOpen: boolean;
  onCreateFolderOpenChange: (open: boolean) => void;
  uploadOpen: boolean;
  onUploadOpenChange: (open: boolean) => void;
  onSuccess: () => void;
}

export function GoogleDriveBrowserOverlays({
  previewFile,
  isSecondAccount,
  parentId,
  driveId,
  createFolderOpen,
  onCreateFolderOpenChange,
  uploadOpen,
  onUploadOpenChange,
  onSuccess,
}: GoogleDriveBrowserOverlaysProps) {
  return (
    <>
      <GoogleDrivePreviewDrawer file={previewFile} isSecondAccount={isSecondAccount} />

      <GoogleDriveCreateFolderModal
        open={createFolderOpen}
        onOpenChange={onCreateFolderOpenChange}
        parentId={parentId}
        driveId={driveId}
        isSecondAccount={isSecondAccount}
        onSuccess={onSuccess}
      />

      <GoogleDriveUploadModal
        open={uploadOpen}
        onOpenChange={onUploadOpenChange}
        parentId={parentId}
        driveId={driveId}
        isSecondAccount={isSecondAccount}
        onSuccess={onSuccess}
      />
    </>
  );
}
